var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 130,
    viewBox: "0 0 157 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 74C152 92.5714 146.11 109.781 133.956 131.985C125.053 148.251 112.998 166.843 97.7491 190.362C92.0435 199.162 85.8906 208.652 79.2882 218.968C78.8887 219.592 77.9709 219.593 77.5689 218.982C73.9766 213.528 70.5218 208.299 67.2033 203.276C47.7682 173.861 33.0098 151.524 22.6939 132.37C10.6858 110.073 5 92.6123 5 74C5 36.1663 37.6249 5 78.5 5C119.375 5 152 36.1663 152 74Z",
    stroke: "#F7F7F7",
    strokeWidth: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 83.5,
    r: 42.5,
    stroke: "#F7F7F7",
    strokeWidth: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.35ee4c07f252781e37e1ddb03fd8e6f3.svg";
export { ForwardRef as ReactComponent };